<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-card class="px-2 pb-2 mb-3">
        <v-card-title primary-title>
          <span class="title">{{ $route.meta.title }}</span>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-slide-y-transition mode="out-in">
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="model.purpose"
                      label="Purpose"
                      :items="purposes"
                      item-text="key"
                      item-value="value"
                      :menu-props="{ auto: true }"
                      prepend-icon="mdi-bullseye"
                      required
                      :rules="[v => !!(v || '').trim() || 'Required']"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                      v-model="model.client_id"
                      label="Client"
                      cache-items
                      :items="clients"
                      item-text="key"
                      item-value="value"
                      :search-input.sync="clientSearch"
                      prepend-icon="mdi-account"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      lazy
                      :close-on-content-click="false"
                      v-model="showDatePicker"
                      transition="scale-transition"
                      full-width
                      :nudge-right="40"
                      max-width="290px"
                      min-width="290px"
                    >
                      <div slot="activator">
                        <v-combobox
                          v-model="model.days"
                          :label="`${model.days.length === 0 ? 'All ' : ''}Days`"
                          chips
                          multiple
                          prepend-icon="event"
                          clearable
                        >
                          <template slot="selection" slot-scope="data">
                            <v-chip close @input="removeDate(data.item)" :selected="data.selected" >
                              <strong>{{ data.item }}</strong> 
                            </v-chip>
                          </template>
                        </v-combobox>
                      </div>
                      <v-form ref="dateForm" @submit.prevent="addDate(selectedDay)" lazy-validation>
                        <v-card>
                          <v-card-title class="pb-0">
                            <h3>Selected date</h3>
                          </v-card-title>
                          <v-card-text class="py-0">
                            <v-text-field
                              v-model="selectedDay"
                              type="date"
                              required
                              :rules="[v => !!(v || '').trim() || 'Required']"
                            />
                          </v-card-text>
                          <v-card-actions class="pt-0">
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="showDatePicker = false">Cancel</v-btn>
                            <v-btn type="submit" flat color="primary">OK</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-form>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn color="primary" style="margin-left: 40px" @click="submit" :loading="loading">Submit</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-slide-y-transition>
        </v-card-text>
      </v-card>
      <UpdateBalances></UpdateBalances>
      <OrderBooks></OrderBooks>
      <OpenOrders></OpenOrders>
    </v-container>
  </v-flex>
</template>

<script>
  import MongoService from '../services/mongo.service'
  import MongoConnector from '../services/mongo-connector.service'
  import MessageDialog from '../libs/message-dialog/'
  import { titleText, sortedUniq, removeEmptyProps } from '../libs/utils.js'
  import UpdateBalances from './Spreadsheet/UpdateBalances'
  import OrderBooks from './Spreadsheet/OrderBooks'
  import OpenOrders from './Spreadsheet/OpenOrders'

  const PURPOSES = ['reporting', 'monitoring'].map(x => ({ key: titleText(x), value: x }))

  export default {
    data () {
      const service = new MongoConnector(null, 'clients', {})
      const todayDate = new Date().toISOString().split('T')[0]
      return {
        service,
        loading: false,
        showDatePicker: false,
        valid: true,
        purposes: PURPOSES,
        clients: [],
        days: [],
        model: {
          purpose: PURPOSES[0].value,
          client_id: null,
          days: []
        },
        selectedDay: todayDate,
        dateValid: true,
        clientSearch: null,
        result: null
      }
    },
    async beforeMount () {
      this.loading = true
      try {
        this.clients = await this.service.find({ projection: { client_id: 1 } })
        this.clients = this.clients.map(x => x.client_id).sort((a, b) => a - b)
        this.clients = [
          { key: 'All', value: null },
          ...this.clients.map(clientId => ({ key: clientId, value: clientId }))
        ]
      } catch (e) {}
      this.loading = false
    },
    components: {
      UpdateBalances,
      OrderBooks,
      OpenOrders
    },
    methods: {
      addDate (date) {
        if (!this.$refs.dateForm.validate()) return
        this.model.days = sortedUniq([...this.model.days, date].sort())
        this.showDatePicker = false
      },
      removeDate (date) {
        this.model.days.splice(this.model.days.indexOf(date), 1)
        this.model.days = [...this.model.days]
      },
      async submit () {
        if (!this.$refs.form.validate()) return
        this.loading = true
        this.result = null
        try {
          const result = await MongoService.spreadsheet(removeEmptyProps({
            ...this.model,
            days: this.model.days.length ? [...this.model.days] : undefined
          }))
          if (result) {
            MessageDialog.showSuccessMessage({ text: 'Your request has been processed' })
          }
          this.result = result
        } catch (e) {}
        this.loading = false
      }
    }
  }
</script>
